    /**
     * @ngdoc directive
     * @name drvAttachmentSelector
     * 
     * @description
     * Allows the selection and modification of attachments. Supports local and ChilliDocs files.
     *
     * @param {AttachmentList} attachments - Attachments list object which contains an array of 'file details' and also has functions to mutate the list. Refer to email/attachment-list.js for more information

     * @param {number} entityId - The ChilliDocs Files will default to being filtered for the entity id.
     *                            If not specified, all chillidocs files will be returned
     * @param {bool} readOnly - Flag for read only mode, where the attachment list cannot be modified.
     */

(function () {
    'use strict';

    angular
        .module('app')
        .directive('drvAttachmentSelector', drvAttachmentSelector);
            
        drvAttachmentSelector.$inject = [];

        function drvAttachmentSelector() {
            var directive = {
                templateUrl: 'app/controls/attachment-selector.tmpl.html',
                scope: {
                },
                controller: drvAttachmentSelectorCtrl,
                controllerAs: 'drvCtrl',
                bindToController: {
                    attachments: '=',
                    entityId: '=',
                    readOnly: '='
                }
            };

            return directive;
        }

        drvAttachmentSelectorCtrl.$inject = ['FileSelectorService'];

        function drvAttachmentSelectorCtrl(FileSelectorService) {
            /* jshint validthis:true */
            var drvCtrl = this;
            drvCtrl.addFiles = addFiles;
            drvCtrl.removeFile = removeFile;
            drvCtrl.viewFile = viewFile;
            drvCtrl.getFileExtension = getFileExtension;
            drvCtrl.retryFile = retryFile;
            drvCtrl.fileCancellable = fileCancellable;
            drvCtrl.showErrorIcon = showErrorIcon;

            activate();

            function activate() {
            }

            /**
             *
             * Opens the attachment selector, once the user selects file/s these will be added to the attachments array and the upload process will be initiated.
             *
             * @param {string} type - The type of file to be added. Can either be 'ChilliDocs' or 'Local'.
             *
             */
            function addFiles(type) {
                var promise = null;

                if (type === 'ChilliDocs') {
                    promise = FileSelectorService.selectChilliDocsFileDialog(drvCtrl.entityId);
                } else if (type === 'Local') {
                    promise = FileSelectorService.selectLocalFileDialog(true);
                }

                if (!_.isNil(promise)) {
                    return promise
                        .then(addFilesOk);
                }

                function addFilesOk(data) {
                    angular.forEach(data, function (file) {
                        drvCtrl.attachments.add(file);
                    });
                }
            }
            
            /**
             *
             * Remove file from attachments array and deletes persisted data for the file if it exists.
             */
            function removeFile(file) {
                drvCtrl.attachments.remove(file);
            }

            /**
             *
             * Gets the file extension for the supplied file name
             *
             * @returns {string} file extension
             */
            function getFileExtension(fileName) {
                var fileNameParts = fileName.split('.');
                var extension = fileNameParts[fileNameParts.length - 1];

                return extension;
            }

            /**
             *
             * 'Views' the selected file
             */
            function viewFile(file) {
                drvCtrl.attachments.getAttachmentData(file);
            }

            /**
             *
             * Retries the upload process for supplied file.
             */
            function retryFile(file) {
                drvCtrl.attachments.retryUpload(file);
            }

            /**
             * Determines if the files upload can be cancelled
             *
             * @param {Object} file - file details of the file which is to be checked.
             * @returns {bool} Returns true if the files upload can be cancelled.
             */
            function fileCancellable(file) {
                return (!_.isNil(file.UploadProgress) && file.UploadProgress < 100);
            }

            /**
             * Determines if an error icon should be shown for the file
             *
             * @param {Object} file - file details of the file which is to be checked.
             * @returns {bool} Returns true if an error icon should be shown for the file.
             */
            function showErrorIcon(file) {
                return (!_.isNil(file.ErrorMessage));
            }
        }
})();